// import { action, makeAutoObservable, makeObservable, observable, runInAction } from "mobx";
// import firebaseAgent from "../api/firebaseagent";
// import { Product } from "../models/product";
// import { BaseStore } from "./baseStore";
// import { store } from "./store";

// export default class ProductsStore extends BaseStore<Product> {
//     // productreload = true;   

//     constructor() {
//         super();
//         makeObservable(this, {
//         });
//     }

//     // Link this store to the specific service in firebaseAgent
//     protected getService() {
//         // We use the specific service logic defined in the refactored Agent
//         return firebaseAgent.productService; 
//     }

//     // Aliases to match your existing code naming conventions
//     get product() { return this.selectedItem || new Product(); }
//     set product(val: Product) { this.selectedItem = val; }
//     get products() { return this.items; }
//     get recommendedproducts() {return this.items.filter(p => p.brand === this.selectedItem?.brand && p.id !== this.selectedItem?.id).slice(0, 4)}

//     // Unique Product Logic
//     loadProductList = async () => {
//         await this.loadAll();
//     }

//         loadCategoryProductList = async (id:string) =>{
//         await this.loadAll(id,"categoryId");
//     }

//     loadProduct = async (id: string) => {
//         return this.getItem(id);
//     }
//     get productByName() {
//         return [...this.items].sort((a, b) => {
//             // Add sorting logic if needed
//             return 0;
//         });
//     }
// }

import { makeObservable, computed, action, runInAction, override } from "mobx";
import firebaseAgent from "../api/firebaseagent";
import { Product } from "../models/product";
import { BaseStore } from "./baseStore";
import { RootStore } from "./rootStore";

export default class ProductsStore extends BaseStore<Product> {

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            // Computed properties for filtered/sorted data
            product: computed,
            products: computed,
            recommendedproducts: computed,
            productByName: computed,
            // Actions for modifying state
            update: action,
            // Inherited from BaseStore (MUST use override)
            delete: action,
            //loadAll: override,
            //getItem: override
        });
    }

    protected getService() {
        return firebaseAgent.productService; 
    }

    // --- Accessors ---
    get product() { return this.selectedItem || new Product(); }
    set product(val: Product) { this.selectedItem = val; }
    get products() { return this.items; }
    
    get recommendedproducts() {
        return this.items
            .filter(p => p.brand === this.selectedItem?.brand && p.id !== this.selectedItem?.id)
            .slice(0, 4);
    }

    // --- Data Loading ---
    loadProductList = async () => {
        await this.loadAll();
    }

    loadCategoryProductList = async (id: string) => {
        await this.loadAll(id, "categoryId");
    }

    loadProduct = async (id: string) => {
        return this.getItem(id);
    }

    // --- Admin Operations ---
    
    update = async (id: string, updates: Partial<Product>) => {
        this.isLoaded = true;
        try {
            await this.getService().update(id, updates);
            runInAction(() => {
                const index = this.items.findIndex(p => p.id === id);
                if (index !== -1) {
                    // Merge existing product with new updates
                    this.items[index] = { ...this.items[index], ...updates };
                }
                this.isLoaded = false;
            });
        } catch (error) {
            console.error("Failed to update product:", error);
            runInAction(() => this.isLoaded = false);
        }
    }
    
    delete = async (id: string) => {
        if (!window.confirm("Are you sure you want to delete this product?")) return;
        
        this.isLoaded = true;
        try {
            await this.getService().delete(id);
            runInAction(() => {
                this.items = this.items.filter(p => p.id !== id);
                this.isLoaded = false;
            });
        } catch (error) {
            console.error("Failed to delete product:", error);
            runInAction(() => this.isLoaded = false);
        }
    }

    get productByName() {
        return [...this.items].sort((a, b) => a.title.localeCompare(b.title));
    }
}